import { render, staticRenderFns } from "./MdElementList.vue?vue&type=template&id=4b1ceb0a&scoped=true&"
import script from "./MdElementList.vue?vue&type=script&lang=js&"
export * from "./MdElementList.vue?vue&type=script&lang=js&"
import style0 from "./MdElementList.vue?vue&type=style&index=0&id=4b1ceb0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1ceb0a",
  null
  
)

export default component.exports